import { logger as config } from "@/config";

const getTimeStamp = () => new Date().toLocaleTimeString();

class Logger {
  constructor({ enabled = true, senders = [] }) {
    this.enabled = enabled;
    this.senders = senders;
  }
  _output(type, messages) {
    if (this.enabled || window.debug) {
      console[type || "log"](...messages);
    }
  }
  log(from, message, ...args) {
    if (!this.senders.length || this.senders.includes(from)) {
      this._output("info", [
        `${getTimeStamp()} [${from}] - ${message}`,
        ...args
      ]);
    }
  }
  deprecation(message) {
    this._output("warn", [`${getTimeStamp()} [DEPRECATION] - ${message}`]);
  }
  error(error) {
    this._output("error", [getTimeStamp(), error]);
  }
  request({ from, title, request, response }) {
    this.log(from, title);
    this.log(from, "request:", request);
    this.log(from, "response:", response);
  }
}

export default new Logger({
  senders: config.senders,
  enabled: config.enabled
});
